/** Bound both transport and UI completion, even if a transport fails to observe abort. */
export async function boundedRequest<T>(request: (signal: AbortSignal) => Promise<T>, cancel: AbortSignal, timeoutMessage: string, timeoutMs = 30_000): Promise<T> {
  const controller = new AbortController();
  const relay = () => controller.abort(cancel.reason);
  cancel.addEventListener('abort', relay, { once: true });
  if (cancel.aborted) relay();
  const timer = setTimeout(() => controller.abort(new Error(timeoutMessage)), timeoutMs);
  let onAbort!: () => void;
  const aborted = new Promise<never>((_, reject) => {
    onAbort = () => reject(controller.signal.reason ?? new Error('Request cancelled.'));
    controller.signal.addEventListener('abort', onAbort, { once: true });
    if (controller.signal.aborted) onAbort();
  });
  try { return await Promise.race([aborted, controller.signal.aborted ? aborted : request(controller.signal)]); }
  finally { clearTimeout(timer); controller.signal.removeEventListener('abort', onAbort); }
}
